import { render, staticRenderFns } from "./sports-management.vue?vue&type=template&id=b9d13422&scoped=true&"
import script from "./sports-management.vue?vue&type=script&lang=js&"
export * from "./sports-management.vue?vue&type=script&lang=js&"
import style1 from "./sports-management.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d13422",
  null
  
)

export default component.exports